export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_q01_a.1b9a58ab.png";